(function () {
  if (window.__cartBubbleSyncInstalled) return;
  window.__cartBubbleSyncInstalled = true;

  const CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartRequest(url) {
    if (!url) return false;
    try {
      const fullUrl = typeof url === 'string' ? url : (url.url || '');
      return CART_ENDPOINTS.some(endpoint => fullUrl.includes(endpoint));
    } catch (e) {
      return false;
    }
  }

  function formatCartMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const moneyFormat =
          (window.theme && window.theme.moneyFormat) ||
          window.Shopify.money_format ||
          '${{amount}}';

        return window.Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (e) {}

    try {
      return new Intl.NumberFormat('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format((cents || 0) / 100);
    } catch (e) {
      return String((cents || 0) / 100);
    }
  }

  let refreshTimer = null;

  function queueHeaderRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshHeaderCartIcon, 350);
  }

  async function refreshHeaderCartIcon() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=header`, {
        credentials: 'same-origin'
      });

      if (!res.ok) throw new Error('');

      const data = await res.json();
      const headerHtml = data.header || Object.values(data)[0];
      if (!headerHtml) throw new Error('Respuesta sin HTML de header');

      const parser = new DOMParser();
      const doc = parser.parseFromString(headerHtml, 'text/html');
      const newCartIconBubble = doc.querySelector('#cart-icon-bubble');
      const currentCartIconBubble = document.querySelector('#cart-icon-bubble');

      if (newCartIconBubble && currentCartIconBubble) {
        currentCartIconBubble.outerHTML = newCartIconBubble.outerHTML;

        const newCartTotalPrice = doc.querySelector('#cart-total-price');
        const currentCartTotalPrice = document.querySelector('#cart-total-price');

        if (newCartTotalPrice && currentCartTotalPrice) {
          currentCartTotalPrice.outerHTML = newCartTotalPrice.outerHTML;
        } else if (!currentCartTotalPrice) {
          refreshCountFallback();
        }
      } else {
        refreshCountFallback();
      }
    } catch (err) {
      refreshCountFallback();
    }
  }

  async function refreshCountFallback() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
      let bubble = cartLink.querySelector('.cart-count-bubble');

      if (cart.item_count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = `
            <span aria-hidden="true"></span>
            <span class="visually-hidden"></span>
          `;
          cartLink.appendChild(bubble);
        }

        const visible = bubble.querySelector('span[aria-hidden="true"]');
        const hidden = bubble.querySelector('.visually-hidden');

        if (visible) visible.textContent = String(cart.item_count);
        if (hidden) hidden.textContent = `${cart.item_count} artículos`;
      } else {
        if (bubble) bubble.remove();
      }

      let totalEl = document.querySelector('#cart-total-price');
      if (!totalEl) {
        totalEl = document.createElement('div');
        totalEl.id = 'cart-total-price';
        totalEl.className = 'header__cart-total-price';

        if (cartLink.parentNode) {
          cartLink.parentNode.appendChild(totalEl);
        }
      }

      if (totalEl) {
        totalEl.textContent = formatCartMoney(cart.total_price);

        if (cart.item_count === 0) {
          totalEl.classList.add('is-empty'); 
        } else {
          totalEl.classList.remove('is-empty');
        }
      }

    } catch (e) {
    }
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    try {
      const requestUrl = args[0];
      if (response && response.ok && isCartRequest(requestUrl)) {
        queueHeaderRefresh();
      }
    } catch (e) {}
    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__requestUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      try {
        if (this.status >= 200 && this.status < 300 && isCartRequest(this.__requestUrl)) {
          queueHeaderRefresh();
        }
      } catch (e) {}
    });
    return originalSend.apply(this, arguments);
  };

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('#multivariants_add_to_cart_button');
    if (!btn) return;
    setTimeout(queueHeaderRefresh, 500);
    setTimeout(queueHeaderRefresh, 1200);
  });

})();